module.exports = __webpack_public_path__ + "img/default-desktop-arabic.701e7706.png";